import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import Iconify from "../iconify/Iconify";
import { useNavigate } from "react-router-dom";
import useWithUrlTenant from "src/hooks/useTenant";
export default function DailyPacksTable({ rows }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPack, setSelectedPack] = useState(null);
  const navigate = useNavigate();
  const withTenant = useWithUrlTenant();
  const handleMenuOpen = (event, packType) => {
    setAnchorEl(event.currentTarget);
    setSelectedPack(packType);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedPack(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    if (selectedPack !== null) {
      navigate(withTenant(`/dashboard/packs/${selectedPack}`));
    }
  };

  if (!rows || rows.length === 0) return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Daily Pack Types
      </Typography>
      <Paper sx={{ width: "100%", overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Pack</TableCell>
              <TableCell align="center">Opened Last Day</TableCell>
              <TableCell align="center">Unique Users Last Day</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.type}>
                <TableCell sx={{ color: "#6A707E", fontWeight: "600" }}>
                  {row.name}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "#6A707E", fontWeight: "600" }}
                >
                  {row.stats?.openedLastDayCount ?? 0}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "#6A707E", fontWeight: "600" }}
                >
                  {row.stats?.uniqueUsersLastDayCount ?? 0}
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={(e) => handleMenuOpen(e, row.type)}>
                    <Iconify icon="eva:more-vertical-outline" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon="eva:edit-outline" width={20} sx={{ mr: 1 }} />
          Edit
        </MenuItem>
      </Menu>
    </Box>
  );
}
